import { toZonedTime } from "date-fns-tz";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import startOfDay from "date-fns/startOfDay";
import subDays from "date-fns/subDays";

export const getTimeRangeForDays = (days: number) => {
  const now = new Date();

  const endDate = toZonedTime(now, "Asia/Hong_Kong").getTime();
  const startDate = toZonedTime(subDays(now, days), "Asia/Hong_Kong").getTime();

  return {
    endDate,
    startDate,
  };
};

export const toHongKongTimestamp = (date: Date, boundary: "end" | "start") => {
  const bounded = boundary === "start" ? startOfDay(date) : endOfDay(date);
  return toZonedTime(bounded, "Asia/Hong_Kong").getTime();
};

export const formatDateRangeText = (startDate: Date, endDate: Date) =>
  `${format(startDate, "dd/MM/yyyy")} - ${format(endDate, "dd/MM/yyyy")}`;

export type TimeRangePreset = {
  days: number;
  label: string;
};

export const TimeRangePresets: TimeRangePreset[] = [
  { days: 1, label: "Past 24 Hours" },
  { days: 7, label: "7 Days" },
  { days: 60, label: "60 Days" },
  { days: 365, label: "12 Months" },
];
